export const MutationKeys = {
  LOGIN: "Login",
  FINALIZE_PAYMENT: "FinalizePayment",
  PROCESS_GATEWAY: "ProcessGateway",
  CREATE_ORGANISATION_WITH_ADMIN: "CreateOrganisationWithAdmin",
  SEND_INVITATIONS: "SendIvitation",
};

export const QueryKeys = {
  Organisation: "organisation",
  INVITED_STUDENTS: "invited-students",
  MAINTENANCE: "Maintenance",
  GET_COUNTRY: "GetCountry",
};
